import React, { useState } from 'react'
import { useParams } from 'react-router'
import {
  GENERIC_PASSWORD_CHANGE_ERROR,
  PASSWORD_CHANGE_ACTION,
  PASSWORD_CHANGE_TITLE,
} from '../../constants/ui.labels'
import AccountRecoveryBase from '../../components/AccountRecoveryBase'
import PasswordChangeFieldGroup from '../../components/PasswordChangeFieldGroup'
import ContentHeader from '../../components/ContentHeader'
import Error from '../../components/Error'
import SecureForm from '../../components/SecureForm'
import { LOGIN_ROOT } from '../../constants/routes'
import mapError from '../../utils/mapError/userManagement'
import Box from '@talkdesk/cobalt-react-box'
import { navigateTo } from 'mfa'

const INITIAL_FORM_DATA = {
  password: '',
  passwordConfirmation: '',
  error: null,
  isValid: false,
}

/** @param {{ processed: any, errorCode?: any, siteKey: any, disabledForm?: boolean, match?: any, onSubmit: any, onExecuteRecaptcha: any }} props */
const PasswordResetConfirmation = ({
  processed,
  errorCode = null,
  siteKey,
  disabledForm = false,
  match,
  onSubmit,
  onExecuteRecaptcha,
}) => {
  const params = useParams()
  const token = (match && match.params && match.params.token) || params.token
  const [formData, setFormData] = useState(INITIAL_FORM_DATA)
  const [displayToastError, setDisplayToastError] = useState(false)

  const getErrorMessage = (code) =>
    formData.error ||
    (code && mapError(code, GENERIC_PASSWORD_CHANGE_ERROR)) ||
    null

  const handleFormSubmit = (recaptchaResponse) => {
    const { password, passwordConfirmation } = formData
    onSubmit({
      password,
      passwordConfirmation,
      recaptchaResponse,
      token,
    })
    setDisplayToastError(true)
  }

  const showToastError =
    (formData.error && !formData.isValid) || displayToastError

  if (processed) {
    navigateTo(LOGIN_ROOT)
    return null
  }

  return (
    <AccountRecoveryBase.Centered>
      <React.Fragment>
        <ContentHeader title={PASSWORD_CHANGE_TITLE} />
        {showToastError ? <Error message={getErrorMessage(errorCode)} /> : null}
        <SecureForm
          disabledForm={disabledForm}
          onSubmit={handleFormSubmit}
          onExecuteRecaptcha={onExecuteRecaptcha}
          isFormValid={formData.isValid}
          submitLabel={PASSWORD_CHANGE_ACTION}
          siteKey={siteKey}
        >
          <Box paddingY='2'>
            <PasswordChangeFieldGroup
              formData={formData}
              onFormChange={setFormData}
              disabledForm={disabledForm}
            />
          </Box>
        </SecureForm>
      </React.Fragment>
    </AccountRecoveryBase.Centered>
  )
}

export default PasswordResetConfirmation
